import EmptyCode from "!!raw-loader!./masonrygrid/Empty.tsx";
import LeftRightCode from "!!raw-loader!./masonrygrid/LeftRight.tsx";
import TopDownCode from "!!raw-loader!./masonrygrid/TopDown.tsx";
import Pane, { paneComponent, PaneProps } from "../Pane";
import React from "react";
import { ComponentProps } from "../Component";
import Empty from "./masonrygrid/Empty";
import LeftRight from "./masonrygrid/LeftRight";
import TopDown from "./masonrygrid/TopDown";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Left to Right Masonry Grid", LeftRightCode, LeftRight, "Uses explicit height and width for masonry grid component"),
		paneComponent("Top-Down Masonry Grid", TopDownCode, TopDown, "Detects container height and width for masonry grid"),
		paneComponent("Empty Masonry Grid", EmptyCode, Empty),
	];

	return (
		<Pane
			components={components}
			imports='import {MasonryGrid} from "designSystem/index";'
			{...props}
		/>
	);
};